export const MAXIMUM_ALLOWED_YEAR = new Date().getFullYear() + 1;
